import { feberApiDelete, feberApiGet, feberApiPatch, feberApiPost, feberApiPut } from '../../../../../services/commonServices';
import { IFileProvisionConfig } from './types';

// API service functions (to be implemented with actual API calls)

export const getAllProvisionerConfigsService = async (): Promise<IFileProvisionConfig[]> => {
    try {
        return await feberApiGet<IFileProvisionConfig[]>("FileProvision/GetAllConfigs");
    } catch (error: any) {
        console.error("Failed to get all roles:", error);
        throw error;
    }
};


export const createConfigService = async (config: Partial<IFileProvisionConfig>): Promise<IFileProvisionConfig> => {
    try {
        return await feberApiPost<IFileProvisionConfig>("FileProvision/AddConfig", config);
    } catch (error: any) {
        console.error("Failed to get all roles:", error);
        throw error;
    }
};

export const updateConfigService = async (config: IFileProvisionConfig): Promise<IFileProvisionConfig> => {
    try {
        return await  feberApiPut<IFileProvisionConfig>("FileProvision/UpdateConfig", config);
    } catch (error: any) {
        console.error("Failed to get all roles:", error);
        throw error;
    }
};

export const deleteBulkConfigsService = async (configIds: number[]): Promise<boolean> => {
    try {
        return await feberApiDelete<boolean>("FileProvision/DeleteConfigs", { configIds });
    } catch (error: any) {
        console.error("Failed to delete feature:", error);
        throw error;
    }
};

export const triggerWebjob = async (): Promise<boolean> => {
    try {
        return await feberApiPost<boolean>("FileProvision/TriggerWebJob", {});
    } catch (error: any) {
        console.error("Failed to trigger webjob:", error);
        throw error;
    }
}

export const toggleProvisionerStatusService = async (configId: number, isActive: boolean): Promise<IFileProvisionConfig> => {
    try {
        return await feberApiPatch<IFileProvisionConfig>(`FileProvision/ToggleConfigActiveStatus?configId=${configId}&isActive=${isActive}`);
    } catch (error: any) {
        console.error("Failed to toggle provisioner status:", error);
        throw error;
    }
}